export const themeShowcaseRoutes = {
  THEME_SHOWCASE: {
    id: 'theme_showcase',
    label: 'Theme Showcase',
    path: '/theme-showcase/',
    auth: true,
  },
};
